import React, { useState, useEffect } from 'react'
import { useSpring, animated } from 'react-spring';

export const FadeIn = ({showItem, children, delay = 0, duration = 1600}) => {
    const [show, set] = useState(false)
    useEffect(() => set(showItem),[showItem])

    const props = useSpring({opacity: show ? 1 : 0,config: {duration, delay}})

    return show && <animated.div style={props}>{children}</animated.div>
    
}
